module.exports = __webpack_public_path__ + "static/img/jkfx_zzfx_icon.png";